var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_description_24px",
    className: "cls-2",
    d: "M11.967,2H5.593A1.591,1.591,0,0,0,4.008,3.593L4,16.341a1.591,1.591,0,0,0,1.585,1.593h9.569a1.6,1.6,0,0,0,1.593-1.593V6.78Zm1.593,12.748H7.187V13.154h6.374Zm0-3.187H7.187V9.967h6.374ZM11.17,7.577V3.2l4.382,4.382Z",
    transform: "translate(-0.628 -0.471)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.4c8e94bb98dc33581aa9369f649d5c31.svg";
export { ForwardRef as ReactComponent };